import React from 'react';
import { C } from '../../styles/tokens';
import { Ico } from '../ui/Icons';
import useIsMobile from '../../hooks/useIsMobile';

export const CREATE_AUDIO_USECASES = [
    {
        id: 'tiktok', label: 'TikTok', desc: 'Short-form voiceover, punchy hooks',
        grad: 'linear-gradient(135deg,#0F172A,#334155)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M19.5 8.1a5.6 5.6 0 0 1-3.4-1.1v6.8a5.9 5.9 0 1 1-5.9-5.9c.2 0 .5 0 .7.1v3a2.9 2.9 0 1 0 2.2 2.8V2h3a5.6 5.6 0 0 0 3.4 4.6z" /></svg>
        ),
    },
    {
        id: 'youtube', label: 'YouTube', desc: 'Narration for videos & Shorts',
        grad: 'linear-gradient(135deg,#B91C1C,#EF4444)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M23 7.2a3 3 0 0 0-2.1-2.1C19 4.5 12 4.5 12 4.5s-7 0-8.9.6A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12 31 31 0 0 0 1 16.8a3 3 0 0 0 2.1 2.1c1.9.6 8.9.6 8.9.6s7 0 8.9-.6a3 3 0 0 0 2.1-2.1A31 31 0 0 0 23.5 12 31 31 0 0 0 23 7.2zM9.8 15.1V8.9L16 12z" /></svg>
        ),
    },
    {
        id: 'instagram', label: 'Instagram Reels', desc: 'Voiceovers for Reels & Stories',
        grad: 'linear-gradient(135deg,#7C3AED,#EC4899,#F59E0B)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="4.2" /><circle cx="17.6" cy="6.4" r="1.1" fill="#fff" stroke="none" /></svg>
        ),
    },
    {
        id: 'podcast', label: 'Podcast', desc: 'Intros, ads, and full episodes',
        grad: 'linear-gradient(135deg,#5B21B6,#8B5CF6)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" /><path d="M19 10a7 7 0 0 1-14 0M12 19v3M8 22h8" /></svg>
        ),
    },
    {
        id: 'ads', label: 'Ads & Promos', desc: 'Commercials and paid social spots',
        grad: 'linear-gradient(135deg,#B45309,#F59E0B)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11l18-7-7 18-2.5-7.5z" /></svg>
        ),
    },
    {
        id: 'audiobook', label: 'Audiobook', desc: 'Long-form narration & storytelling',
        grad: 'linear-gradient(135deg,#065F46,#10B981)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V2H6.5A2.5 2.5 0 0 0 4 4.5z" /><path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5" /></svg>
        ),
    },
    {
        id: 'elearning', label: 'E-learning', desc: 'Courses, tutorials, and training',
        grad: 'linear-gradient(135deg,#1E40AF,#3B82F6)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10L12 5 2 10l10 5z" /><path d="M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5" /></svg>
        ),
    },
    {
        id: 'other', label: 'Something else',
        grad: 'linear-gradient(135deg,#475569,#94A3B8)',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round"><path d="M12 5v14M5 12h14" /></svg>
        ),
    },
];

export default function CreateAudioModal({ show, onClose, onPick }) {
    const isMobile = useIsMobile();
    if (!show) return null;

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed', inset: 0, background: 'rgba(15,23,42,.48)', zIndex: 1050,
                display: 'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent: 'center',
                padding: isMobile ? 0 : 24,
            }}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: C.w,
                    borderRadius: isMobile ? '18px 18px 0 0' : 18,
                    width: isMobile ? '100%' : 620, maxWidth: '100%',
                    maxHeight: isMobile ? '88vh' : '84vh', overflowY: 'auto',
                    boxShadow: '0 25px 60px rgba(0,0,0,.28)', padding: isMobile ? '20px 16px' : '24px 26px',
                    position: 'relative', boxSizing: 'border-box',
                }}
            >
                <button
                    onClick={onClose}
                    style={{ position: 'absolute', top: 14, right: 14, background: 'none', border: 'none', cursor: 'pointer', padding: 6, display: 'flex' }}
                >
                    <Ico n="x" size={16} color={C.n500} />
                </button>

                <div style={{ fontSize: isMobile ? 17 : 19, fontWeight: 800, color: C.n900, letterSpacing: '-.015em', marginBottom: 4, paddingRight: 24 }}>
                    What are you creating?
                </div>
                <div style={{ fontSize: 13, color: C.n500, marginBottom: 18 }}>
                    Pick a platform or use case so we know what you're creating this for.
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: isMobile ? 8 : 10 }}>
                    {CREATE_AUDIO_USECASES.map(uc => (
                        <button
                            key={uc.id}
                            onClick={() => onPick(uc.id)}
                            style={{
                                display: 'flex',
                                flexDirection: isMobile ? 'column' : 'row',
                                alignItems: isMobile ? 'flex-start' : 'center',
                                gap: isMobile ? 8 : 12,
                                padding: isMobile ? '12px 10px' : '13px 14px',
                                background: C.w, border: `1px solid ${C.n200}`, borderRadius: isMobile ? 11 : 13,
                                cursor: 'pointer', textAlign: 'left', transition: 'border-color .12s, box-shadow .12s',
                                minWidth: 0,
                            }}
                            onMouseEnter={e => { e.currentTarget.style.borderColor = C.n400; e.currentTarget.style.boxShadow = '0 4px 12px rgba(15,23,42,.07)'; }}
                            onMouseLeave={e => { e.currentTarget.style.borderColor = C.n200; e.currentTarget.style.boxShadow = 'none'; }}
                        >
                            <span style={{
                                width: isMobile ? 34 : 40, height: isMobile ? 34 : 40, borderRadius: isMobile ? 10 : 11,
                                background: uc.grad, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                transform: isMobile ? 'scale(.8)' : 'none',
                            }}>
                                {uc.icon}
                            </span>
                            <span style={{ minWidth: 0, flex: isMobile ? 'none' : 1, width: isMobile ? '100%' : 'auto' }}>
                                <span style={{ display: 'block', fontSize: isMobile ? 12.5 : 14, fontWeight: 700, color: C.n900, overflowWrap: 'break-word' }}>{uc.label}</span>
                                {uc.desc && (
                                    <span style={{ display: 'block', fontSize: isMobile ? 10 : 11.5, color: C.n500, marginTop: 1, overflowWrap: 'break-word' }}>{uc.desc}</span>
                                )}
                            </span>
                            {!isMobile && <Ico n="chevR" size={12} color={C.n400} />}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
